import App from "./App";
import router from "./router";
import {createApp} from 'vue'
import VueModalTor from "vue-modaltor/dist/vue-modaltor.common";
import "vue-modaltor/dist/vue-modaltor.css";

const app = createApp(App);
app.use(router);
app.use(VueModalTor, {
    bgPanel: "#7957d5"
});
app.mount('#app');
